import labels from "../../../config/labels";
import types from "../../../config/types";

export const getCTAText = ({features, dealData, userLoggedIn, upgradeCheckDone, eligibleUpgradeList}) => {
  if (!features?.upgradeChecksEnabled) {
    return labels.lbl_do_an_upgrade_check;
  } else if (!upgradeCheckDone) {
    if (userLoggedIn && eligibleUpgradeList?.length == 0) {
      if (!features.upgradeEnabled) {
        return labels.deal_details.lbl_upgrade_this_deal;
      }

      return dealData?.promotion_tag_label == types.TYPE_PREORDER
        ? labels.lbl_preorder_now
        : labels.deal_details.lbl_add_deal_cart;
    } else {
      return labels.lbl_do_an_upgrade_check;
    }
  } else {
    if (!features.upgradeEnabled) {
      return labels.deal_details.lbl_upgrade_this_deal;
    }

    return dealData?.promotion_tag_label == types.TYPE_PREORDER
      ? labels.lbl_preorder_now
      : labels.deal_details.lbl_add_deal_cart;
  }
};
